import { DocumentNode, QueryHookOptions, useQuery } from '@apollo/client'
import { useLocation } from 'react-router-dom'

import { NetworkError } from '../lib/custom-errors'
import getPhoenixUrlParams from '../lib/get-phoenix-url-params'

interface Result<Q> {
  cartData?: Q
  isCartLoading: boolean
}

interface CartQueryVariables {
  cartId: string
}

const useCart = <Q>(query: DocumentNode, options?: QueryHookOptions<Q, CartQueryVariables>): Result<Q> => {
  const location = useLocation()
  const { cartId } = getPhoenixUrlParams(location.search)

  const {
    data: cartData,
    loading: isCartLoading,
    error,
  } = useQuery<Q, CartQueryVariables>(query, {
    ...options,
    variables: { cartId: cartId as string },
  })

  if (error) {
    if (error.networkError) {
      throw new NetworkError(
        'There was a connection error when trying to read the cart data',
        error.networkError.message,
      )
    }

    throw new Error(`${error.name} - ${error.message}`)
  }

  return { cartData, isCartLoading }
}

export default useCart
